import { useState, useRef, useCallback, useEffect } from "react";

// Ortak kat planı "sığdır/zoom" mantığı (Şema Editörü + Operasyon Panosu).
// Mantıksal tuval boyutu her iki sayfada 1560x1900; bu hook fit-to-view ölçeğini üretir.
export function useFloorFit(floorTables, floorElements, ready, refitKey) {
  const [zoom, setZoom] = useState(1);
  const viewportRef = useRef(null);

  const zoomBy = useCallback((delta) => {
    setZoom(z => Math.min(1.6, Math.max(0.4, +(z + delta).toFixed(2))));
  }, []);
  const resetZoom = useCallback(() => setZoom(1), []);

  const fitToView = useCallback(() => {
    const vp = viewportRef.current;
    if (!vp) return;
    if (!floorTables.length && !floorElements.length) { setZoom(1); return; }
    let maxX = 300, maxY = 200;
    floorTables.forEach(t => { maxX = Math.max(maxX, t.x + 150); maxY = Math.max(maxY, t.y + 130); });
    floorElements.forEach(e => { maxX = Math.max(maxX, e.x + (e.width || 120)); maxY = Math.max(maxY, e.y + (e.height || 60)); });
    const availW = vp.clientWidth - 32, availH = vp.clientHeight - 32;
    // Tüm planı (hem en hem boy) ekrana sığdır; %3 tampon son satırın kırpılmasını önler.
    const fitBoth = Math.min(availW / maxX, availH / maxY);
    const z = Math.min(1, fitBoth * 0.97);
    setZoom(+Math.max(0.35, z).toFixed(2));
    vp.scrollTo({ left: 0, top: 0 });
  }, [floorTables, floorElements]);

  // Açılışta / kat değişince / yeniden boyutlanınca otomatik sığdır
  useEffect(() => {
    if (!ready) return;
    const id = setTimeout(() => fitToView(), 250);
    const onResize = () => fitToView();
    window.addEventListener("resize", onResize);
    return () => { clearTimeout(id); window.removeEventListener("resize", onResize); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, refitKey]);

  return { zoom, setZoom, viewportRef, zoomBy, resetZoom, fitToView };
}

export default useFloorFit;
